module.exports = __webpack_public_path__ + "static/img/title_zh@2x.a9e31ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/UID/title_zh@2x.png
// module id = CXWE
// module chunks = 1